import { render, staticRenderFns } from "./CollectionItem.vue?vue&type=template&id=4a5676e4&"
import script from "./CollectionItem.vue?vue&type=script&lang=js&"
export * from "./CollectionItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VTooltip})
